import {BrowserRouter, Route} from 'react-router-dom';

import Header from './Header';
import Routes from '../routes/Routes';
import Footer from "./Footer";
import {AppContextProvider} from "../context/AppContext";
import React, {useEffect, useState} from "react";
import logo from "../assets/images/logo.jpg";
import {getBanners} from "../libs/api";

const Layout = () => {
    const [banner, setBanner] = useState(null);
    const [announcement, setAnnouncement] = useState(null);
    const [showAnnouncement, setShowAnnouncement] = useState(false);

    useEffect(() => {
        const fetchBanners = async () => {
            try {
                const {data: result} = await getBanners();
                if (result && result.banners) {
                    setBanner(result.banners?.content);
                }

                if (result && result.announcement) {
                    setAnnouncement(result.announcement);
                    setShowAnnouncement(true);
                }
            } catch (error) {
                console.error('Error fetching banners:', error);
                setBanner(null);
                setShowAnnouncement(false);
            }
        };

        fetchBanners();
    }, []);

    const closeAnnouncement = () => {
        setShowAnnouncement(false);
    };

    return (
        <BrowserRouter>
            <Route
                render={(props) => (
                    <div className={`app-body`}>
                        <div className="app-header-body">
                            <img src={logo} alt={`logo`}/>
                        </div>
                        {showAnnouncement && (
                            <div className="banner alert alert-warning mx-auto">
                                {/* Close button */}
                                <button
                                    onClick={closeAnnouncement}
                                    className="btn btn-link text-dark close-btn"
                                >
                                    <span>&times;</span> {/* Close icon */}
                                </button>
                                <p style={{fontWeight: 500, fontSize: 'large'}}>{announcement.title}</p>
                                <p>{announcement.message}</p>
                            </div>
                        )}
                        <Header {...props} banner={banner}/>
                        <div className={`container app-content`}>
                            <div className={`app`}>
                                <AppContextProvider>
                                    <Routes/>
                                </AppContextProvider>
                            </div>
                        </div>
                        <Footer {...props} />
                    </div>
                )}
            />
        </BrowserRouter>
    );
};

export default Layout;
